import React from 'react';
import DocuSign from './DocuSign';
import './App.css';
import {
  BrowserRouter as Router,
  Switch,
  Route
} from "react-router-dom";

function App() {
  return (
    <div className="App">
      <Router>
        <Switch>
          <Route path="/:id">
            <DocuSign />
          </Route>
          <Route path="/">
            Invalid url. Please click the correct url
          </Route>
        </Switch>
      </Router>
    </div>
  );
}

export default App;
